import { useNavigate } from "react-router-dom";
import MainContainer from "../../components/MainContainer";
import { ReactComponent as ChevronSvg } from "../../assets/icons/chevronLeft.svg";
import {
  BackButton,
  Container,
  Image,
  ImageContainer,
  List,
  ListItem,
  Text,
  TextContainer,
  Title,
} from "./TutorialsPages.styles";

import Image1 from "../../assets/images/Image01.png";
import Image2 from "../../assets/images/Image02.png";
import Image3 from "../../assets/images/Image03.png";
import Image4 from "../../assets/images/Image04.png";
import Image5 from "../../assets/images/Image05.png";

const TelegramTutorialPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);
  };
  return (
    <MainContainer>
      <Container>
        <BackButton onClick={handleBack}>
          <ChevronSvg />
          Back
        </BackButton>
        <TextContainer>
          <Title>How to purchase credits using Telegram</Title>
          <Text>
            Purchasing our subscription through Telegram is a simple two-step
            process:
          </Text>
          <List>
            <ListItem>
              You purchase Stars (via the official{" "}
              <Text
                $link
                onClick={() => window.open("https://t.me/PremiumBot", "_blank")}
              >
                @PremiumBot
              </Text>
              ) from Telegram using your card (or Google Pay, Apple Pay, or
              other methods).
            </ListItem>

            <ListItem>
              You use the Stars you purchased to buy our service (by paying the
              Stars to our bot).
            </ListItem>
          </List>
        </TextContainer>

        <TextContainer>
          <Title>
            Generate an order on our website purchased with Telegram Stars
          </Title>
          <Text>
            On the subscription page, select your desired subscription and click
            to pay using Telegram.
          </Text>
          <ImageContainer>
            <Image src={Image1} />
            <Image src={Image2} />
          </ImageContainer>
        </TextContainer>

        <TextContainer>
          <Title>Buy stars in Telegram App</Title>
          <Text>
            Purchase stars within the Telegram App using your preferred payment
            method. If you already have stars in your balance, you can skip this
            step.
          </Text>
          <ImageContainer>
            <Image src={Image3} />
            <Image src={Image4} />
          </ImageContainer>
        </TextContainer>

        <TextContainer>
          <Title>Buy our credits with stars</Title>
          <Text>
            Once you have enough stars, the next step is to pay the stars to our
            bot to complete the purchase (this is the step most easily
            forgotten).
          </Text>
          <ImageContainer>
            <Image src={Image5} />
          </ImageContainer>
        </TextContainer>

        <TextContainer>
          <Title>Tips</Title>
          <List>
            <ListItem>
              If you have not received your credits, please open the settings
              section in the Telegram App, then click on the "My Stars" area
              below. Check if your purchase of stars from Telegram officially
              was unsuccessful, or if you did not pay the stars to our bot.
            </ListItem>
            <ListItem>
              If you are unable to purchase stars with your card, you can try
              purchasing them using Apple Pay or Google Pay on the mobile
              version of Telegram, or try using the{" "}
              <Text
                $link
                onClick={() =>
                  window.open("https://web.telegram.org/k/", "_blank")
                }
              >
                web version
              </Text>{" "}
              of Telegram to see if your card can complete the payment.
            </ListItem>
            <ListItem>
              The price for purchasing our services through Telegram Stars may
              be higher than our website's listed price (specific prices vary by
              region). However, we are not charging extra. If you check
              Telegram's official{" "}
              <Text
                $link
                onClick={() =>
                  window.open(
                    "https://core.telegram.org/bots/payments-stars#star-pricing",
                    "_blank"
                  )
                }
              >
                documentation
              </Text>
              , you will find that this portion only covers the transaction fees
              charged by Telegram.
            </ListItem>
          </List>
        </TextContainer>
      </Container>
    </MainContainer>
  );
};

export default TelegramTutorialPage;
